
export enum ChangePasswordStepType {
    Unknown = 0,
    EnterOldPassword = 1,
    SendSMSCode = 2,
    EnterSMSCode = 3,
    SendEmailCode = 4,
    EnterEmailCode = 5,
    EnterNewPassword = 6
}

export enum AgreementType{
    Main = 1,
    Second = 2,
}
